const DataTableColumn = require('okCharts/DataTableColumn');

module.exports = DataTableColumn;
